export const state = {
  updateReserve: {},
  reserves: [],
  reserve: {},
  selectedReserveList: [],
  downloadData: [],
  downloadContentType: '',
  templateData: [],
  templateContentType: '',
  total: 0
}
export const mutations = {
  setReserves(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedReserveList.some(
          selectedReserve =>
            selectedReserve.reserveId === response.data['data'][i]['reserveId']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
      response.data['data'][i]['foothold'] = true
    }
    state.reserves = response.data['data']
    state.total = response.data['header']['total']
  },
  setDetail(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = ''
    }
    state.reserve = response.data['data']
  },
  inputUpdate(state, payload) {
    state.updateReserve[payload.name] = payload.value
  },
  updateSelectedReserveList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedReserveList.some(
          reserve => reserve.reserveId === payload[i].reserveId
        )
      ) {
        state.selectedReserveList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedReserveList.some(
          reserve => reserve.reserveId === payload[i].reserveId
        )
      ) {
        const deleteIndex = state.selectedReserveList.findIndex(
          reserve => reserve.reserveId === payload[i].reserveId
        )
        state.selectedReserveList = state.selectedReserveList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedReserveList(state) {
    state.selectedReserveList = []
  },
  downloadFile(state, payload) {
    state.downloadContentType = payload.headers['content-type']
    state.downloadData = payload.data
  },
  downloadTemplate(state, payload) {
    state.templateContentType = payload.headers['content-type']
    state.templateData = payload.data
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reserveModules/reserveMutation.js